export default {
      id: "plus-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.dd84271a.svg#plus",
      toString: function () {
        return this.url;
      }
    }